{
    "locale": "el-GR",
    "General": {
        "OrText": "Ή",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Μετάβαση στο My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Δημιουργία νέου λογαριασμού",
        "ButtonText_SignInToYourAccount": "Σύνδεση στο λογαριασμό σας",
        "ButtonText_StartInterviewWithoutSigningUp": "Ξεκινήστε την συνέντευξη χωρίς εγγραφή",
        "ButtonText_StartInterviewWithoutSigningIn": "Ξεκινήστε την συνέντευξη χωρίς σύνδεση",
        "Navlink_Dashboard": "Πίνακας Ελέγχου",
        "Navlink_MyInterviews": "Οι συνεντεύξεις μου",
        "Navlink_LearnWithHubert": "Μάθετε με τον Hubert",
        "Navlink_HelpCenter": "Κέντρο βοήθειας",
        "MyProfile": "Το προφίλ μου",
        "LogOut": "Αποσύνδεση"
    },
    "Login": {
        "MainTitle": "Θέλεις να δεις τα αποτελέσματα της συνέντευξής σου στο My Hubert",
        "Subtitle": "Συνδεθείτε για να δείτε τα αποτελέσματα, να λάβετε σχόλια, να διαβάσετε συμβουλές και πολλά άλλα.",
        "LoginTitle": "Συνδεθείτε στον λογαριασμό σας στο Hubert",
        "Label_Email": "Ηλεκτρονικό ταχυδρομείο",
        "Label_Password": "Κωδικός πρόσβασης",
        "ButtonText_SignIn": "Σύνδεση",
        "ButtonText_ForgotPassword": "Ξεχάσατε τον κωδικό πρόσβασης",
        "ButtonText_ContinueWithGoogle": "Συνέχεια με Google",
        "OrSeparator": "Ή",
        "Error_Email_Required": "Το email είναι υποχρεωτικό.",
        "Error_Email_Invalid": "Εισάγετε ένα έγκυρο email.",
        "Error_Password_Required": "Ο κωδικός πρόσβασης είναι υποχρεωτικός.",
        "Error_Use_Same_Email_As_Interview": "Παρακαλούμε χρησιμοποιήστε το ίδιο email που χρησιμοποιήσατε στην συνέντευξη"
    },
    "Registration": {
        "MainTitle": "Θέλεις να δεις τα αποτελέσματα της συνέντευξής σου στο My Hubert",
        "Subtitle": "Εγγραφείτε για να δείτε τα αποτελέσματα, να λάβετε σχόλια, να διαβάσετε συμβουλές και πολλά άλλα.",
        "RegistrationTitle": "Δημιουργία λογαριασμού Hubert",
        "BenefitsBox_Title": "Μπορείτε να",
        "BenefitsBox_Point1": "Ανακτήσετε το ιστορικό των συνεντεύξεών σας",
        "BenefitsBox_Point2": "Λάβετε σχόλια για τις συνεντεύξεις σας",
        "BenefitsBox_Point3": "Επαναχρησιμοποιήσετε τις απαντήσεις σε νέες συνεντεύξεις",
        "BenefitsBox_Point4": "Λάβετε συμβουλές για συνεντεύξεις",
        "BenefitsBox_Point5": "Διαβάστε οδηγούς καριέρας",
        "BenefitsBox_Point6": "Και πολλά άλλα",
        "Label_FirstName": "Όνομα",
        "Label_LastName": "Επώνυμο",
        "Label_Email": "Ηλεκτρονικό ταχυδρομείο",
        "Label_Password": "Κωδικός πρόσβασης",
        "Label_PhoneNumber": "Αριθμός τηλεφώνου",
        "Label_TermsOfService": "Αποδέχομαι τους",
        "Label_TermsOfServiceLink": "Όρους χρήσης και Πολιτική Απορρήτου",
        "Placeholder_CountryCode": "Επιλέξτε κωδικό χώρας",
        "Placeholder_PhoneNumber": "6912345678",
        "HelpText_Password": "Ο κωδικός πρόσβασης πρέπει να είναι τουλάχιστον 6 χαρακτήρες.",
        "ButtonText_SignUp": "Εγγραφή",
        "ButtonText_SignUpWithGoogle": "Εγγραφή με Google",
        "OrSeparator": "Ή",
        "Error_FirstName_Required": "Το όνομα είναι υποχρεωτικό.",
        "Error_LastName_Required": "Το επώνυμο είναι υποχρεωτικό.",
        "Error_Email_Required": "Το email είναι υποχρεωτικό.",
        "Error_Email_Invalid": "Εισάγετε ένα έγκυρο email.",
        "Error_Email_Exists": "Το email χρησιμοποιείται ήδη.",
        "Error_Password_Required": "Ο κωδικός πρόσβασης είναι υποχρεωτικός.",
        "Error_Password_6_Characters": "Ο κωδικός πρόσβασης πρέπει να έχει τουλάχιστον 6 χαρακτήρες.",
        "Error_PhoneNumber_Required": "Ο αριθμός τηλεφώνου είναι υποχρεωτικός.",
        "Error_PhoneNumber_Invalid": "Ο αριθμός τηλεφώνου δεν είναι έγκυρος.",
        "Error_PrivacyPolicyCheck_Required": "Πρέπει να αποδεχτείτε την Πολιτική Απορρήτου και τους Όρους Χρήσης."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Για να κάνετε την συνέντευξη, πρέπει απλώς να αποδεχτείτε τους όρους και προϋποθέσεις για τη χρήση του Hubert. Είναι εύκολο, απλά τσεκάρετε το κουτάκι δεξιά.",
        "Subtitle_AfterInterviewCompleted": "Εγγραφείτε για να δείτε τα αποτελέσματα, να λάβετε σχόλια, να διαβάσετε συμβουλές και πολλά άλλα.",
        "PrivacyPolicyText": "Με το πάτημα της εγγραφής συμφωνείτε με την",
        "PrivacyPolicyLink": "Πολιτική Απορρήτου και Όρους Χρήσης",
        "ButtonText_SignUp": "Εγγραφή και μετάβαση στη συνέντευξη",
        "ButtonText_SignUpNormal": "Εγγραφή",
        "ButtonText_SignInInstead": "Κάντε κλικ εδώ για σύνδεση"
    },
    "LoginInviteEmail": {
        "Subtitle": "Συνδεθείτε για να δείτε τα αποτελέσματα, να λάβετε σχόλια, να διαβάσετε συμβουλές και πολλά άλλα."
    },
    "AppMessages": {
        "internal-server-error": "Παρουσιάστηκε απροσδόκητο σφάλμα",
        "invalid-credentials": "Μη έγκυρα στοιχεία. Παρακαλώ προσπαθήστε ξανά.",
        "user-not-found": "Μη έγκυρα στοιχεία. Παρακαλώ προσπαθήστε ξανά.",
        "account-not-found": "Μη έγκυρος λογαριασμός. Παρακαλώ προσπαθήστε ξανά.",
        "verify-email-title": "Επιβεβαιώστε το email σας",
        "verify-email-subtitle": "Παρακαλούμε ελέγξτε το email σας για να επιβεβαιώσετε τον λογαριασμό σας.",
        "email-not-verified-title": "Το email δεν έχει επιβεβαιωθεί",
        "email-not-verified-subtitle": "Παρακαλούμε ελέγξτε το email σας για να επιβεβαιώσετε τον λογαριασμό σας.",
        "verifying-email-title": "Επιβεβαίωση Email",
        "verifying-email-subtitle": "Παρακαλούμε περιμένετε...",
        "sign-in-title": "Σύνδεση",
        "sign-in-subtitle": "Παρακαλούμε περιμένετε...",
        "server-error": "Κάτι πήγε στραβά",
        "hubert-user-exists": "Ο λογαριασμός υπάρχει ήδη",
        "account-exists": "Ο λογαριασμός υπάρχει ήδη",
        "email-verified": "Το email σας έχει επιβεβαιωθεί",
        "email-is-taken": "Το email χρησιμοποιείται ήδη",
        "re-enter-password": "Χρησιμοποιήστε τον κωδικό πρόσβασης για να συνδεθείτε",
        "password-reset": "Ο κωδικός πρόσβασης έχει αλλάξει",
        "re-enter-new-password": "Χρησιμοποιήστε τον νέο σας κωδικό πρόσβασης για να συνδεθείτε",
        "invalid-invitation": "Μη έγκυρη πρόσκληση.",
        "invalid-code": "Μη έγκυρος κωδικός επιβεβαίωσης.",
        "email-already-verified": "Το email έχει ήδη επιβεβαιωθεί",
        "email-mismatch-title": "Αντίφαση Email",
        "email-mismatch-subtitle": "Παρακαλούμε χρησιμοποιήστε το ίδιο email που χρησιμοποιήσατε για να υποβάλετε την αίτηση για τη δουλειά."
    },
    "TransitionPage": {
        "loading-title": "Φόρτωση...",
        "loading-subtitle": "Κάνουμε κάποιες προετοιμασίες...",
        "logout-title": "Φόρτωση...",
        "logout-subtitle": "Αποσυνδέεστε..."
    },
    "ImpersonationPage": {
        "loading-title": "Φόρτωση...",
        "loading-subtitle": "Κάνουμε κάποιες προετοιμασίες..."
    },
    "ProcessInvitation": {
        "loading-title": "Φόρτωση...",
        "loading-subtitle": "Περιμένετε λίγο, καθώς φορτώνουμε τη συνέντευξή σας",
        "InvitationNotFound": "Δεν μπορούμε να βρούμε τη συνέντευξή σας.",
        "InvitationExpired": "Αυτός ο σύνδεσμος για να αποκτήσετε πρόσβαση στη συνέντευξη έχει λήξει.",
        "InvitationExpired_Description1": "Παρακαλούμε ανοίξτε τη συνέντευξη από.",
        "InvitationExpired_Description2": "ή επικοινωνήστε με τον υπεύθυνο πρόσληψης.",
        "InvitationInvalid": "Ο σύνδεσμος για αυτή την πρόσκληση είναι μη έγκυρος.",
        "InterviewCompleted": "Αυτή η συνέντευξη έχει ήδη ολοκληρωθεί."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Οι συνεντεύξεις μου",
            "TableHead_Employer": "Εργοδότης",
            "TableHead_Job": "Θέση",
            "TableHead_Status": "Κατάσταση",
            "TableHead_ApplicationDate": "Ημερομηνία αίτησης",
            "TableBody_StartInterview": "Η συνέντευξη δεν έχει ολοκληρωθεί. Κάντε κλικ εδώ για να ξεκινήσετε ή να συνεχίσετε τη συνέντευξη.",
            "TableBody_NotScored": "Η συνέντευξη έχει ολοκληρωθεί και τα αποτελέσματα θα είναι διαθέσιμα σύντομα.",
            "TableBody_Details": "Κάντε κλικ εδώ για να δείτε τα αποτελέσματα της συνέντευξης και περισσότερα.",
            "ApplicationDate_Invited": "Προσκεκλημένος",
            "ApplicationDate_MinuteAgo": "πριν από λεπτό",
            "ApplicationDate_MinutesAgo": "πριν από {minutes} λεπτά",
            "ApplicationDate_HourAgo": "πριν από μία ώρα",
            "ApplicationDate_HoursAgo": "πριν από {hours} ώρες",
            "ApplicationDate_DayAgo": "πριν από μία μέρα",
            "ApplicationDate_DaysAgo": "πριν από {days} ημέρες",
            "ButtonText_SeeAllInterviews": "Δείτε όλες τις συνεντεύξεις",
            "ButtonText_Details": "Λεπτομέρειες",
            "ButtonText_StartInterview": "Μετάβαση στη συνέντευξη",
            "ButtonText_NotScored": "Αποτελέσματα εκκρεμούν",
            "NoInterviews_Message": "Δεν υπάρχουν καταγεγραμμένες συνεντεύξεις ή προγραμματισμένες συνεντεύξεις για εσάς."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Δεν υπάρχουν αναρτήσεις θέσεων εργασίας αυτή τη στιγμή. Παρακαλώ ελέγξτε ξανά αργότερα."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Η καριέρα μου",
            "Subtitle": "Επιλέξτε τη συνέντευξη για να δείτε την αξιολόγηση και τις προοπτικές σας.",
            "MostRecentInterview": "Πιο πρόσφατη συνέντευξη",
            "ToDo": "Προς εκτέλεση",
            "NoOngoingInterviews_Title": "Δεν έχετε νέες προσκλήσεις συνέντευξης.",
            "NoOngoingInterviews_Subtitle": "Οι νέες συνεντεύξεις Hubert θα εμφανιστούν εδώ μόλις προγραμματιστούν από τους υπεύθυνους πρόσληψης.",
            "NoRecentInterviews_Title": "Δεν υπάρχουν καταγεγραμμένες συνεντεύξεις για εσάς.",
            "NoRecentInterviews_Subtitle": "Μόλις προσκληθείτε για μια συνέντευξη από τους υπεύθυνους πρόσληψης, θα εμφανιστεί παρακάτω.",
            "ButtonText_StartInterview": "Μετάβαση στη συνέντευξη",
            "ButtonText_NotScored": "Αποτελέσματα εκκρεμούν",
            "ButtonText_Details": "Λεπτομέρειες"
        },
        "LearnWithHubert": {
            "Title": "Μάθετε με τον Hubert",
            "Subtitle": "Λάβετε συμβουλές για το πώς να βελτιώσετε τις συνεντεύξεις και την εργασία σας.",
            "PickedForMe": "Πιο πρόσφατα άρθρα",
            "ButtonText_SeeAllArticles": "Δείτε όλα τα άρθρα"
        },
        "HubertTip": {
            "Title": "Συμβουλή από τον Hubert",
            "Subtitle": "Κάντε τις συνεντεύξεις γρηγορότερα.",
            "Description": "Κάνετε αίτηση για μια νέα δουλειά σε παρόμοια θέση με αυτή που κάνατε συνέντευξη με τον Hubert; Μπορείτε να ξαναχρησιμοποιήσετε τις απαντήσεις σας από αυτή τη συνέντευξη και να εξοικονομήσετε χρόνο.",
            "ButtonText_ReadMoreTips": "Διαβάστε περισσότερες συμβουλές"
        },
        "NewCandidateModalPopup": {
            "Title": "Όλα είναι έτοιμα",
            "DescriptionLine1": "Ο λογαριασμός σας είναι τώρα έτοιμος.",
            "DescriptionLine2": "Διαχειριστείτε τις συνεντεύξεις και το προφίλ σας. Δείτε τα αποτελέσματά σας, λάβετε ανατροφοδότηση και μάθετε περισσότερα για το πώς να κάνετε συνεντεύξεις. Καλή διασκέδαση.",
            "ButtonText_LetsGo": "Πάμε"
        },
        "InterviewCompletedModal": {
            "Title": "Καταπληκτική δουλειά",
            "Subtitle": "Ολοκληρώσατε τη συνέντευξή σας.",
            "Description": "Οι υπεύθυνοι πρόσληψης θα εξετάσουν όλες τις αιτήσεις και θα παρέχουν ανατροφοδότηση μέσω email ή τηλεφώνου μόλις έχουν κάτι να πουν.",
            "ButtonText_Continue": "Συνέχεια"
        },
        "LatestJobPostings": {
            "Title": "Πιο πρόσφατες αναρτήσεις θέσεων εργασίας",
            "Subtitle": "Εξερευνήστε άλλες προσφορές από συνεργάτες του Hubert που αναρτήθηκαν πρόσφατα."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Οι συνεντεύξεις μου",
        "MyInterviewsSection_Subtitle": "Επιλέξτε τη συνέντευξη για να δείτε την αξιολόγηση και τις ευκαιρίες καριέρας σας.",
        "MyInterviewsSection_ToDo": "Προς εκτέλεση"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Δείτε όλες τις συνεντεύξεις",
        "InterviewNotFound_Title": "Ωχ. Πρόσβαση αρνηθεί.",
        "InterviewNotFound_Description": "Προσπαθείτε να αποκτήσετε πρόσβαση σε λεπτομέρειες συνέντευξης που δεν σχετίζονται με το λογαριασμό σας.",
        "ButtonText_GoToAllInterviews": "Μετάβαση στις Συνεντεύξεις Μου",
        "InterviewDetails": {
            "Title": "Λεπτομέρειες Συνέντευξης",
            "ForRole": "Για τη θέση",
            "InterviewCompletedOn": "Η συνέντευξη ολοκληρώθηκε στις {{date}} στις {{time}}"
        },
        "MyResult": {
            "Title": "Το αποτέλεσμα μου",
            "Subtitle": "Αξιολογημένος αγώνας.",
            "ButtonText_LearnMore": "Δείτε πώς αξιολογούνται οι απαντήσεις σας",
            "GotPotential_Title": "Ισχυρό δυναμικό, λείπει μία προϋπόθεση",
            "GotPotential_Description": "Οι απαντήσεις σας έδωσαν καλή εικόνα για αυτόν τον τύπο ρόλου. Ταυτόχρονα, μία υποχρεωτική προϋπόθεση για τη συγκεκριμένη θέση μπορεί να λείπει ή να μην φαίνεται καθαρά από τις απαντήσεις σας. Αυτό μπορεί να επηρεάσει τα επόμενα βήματα και εξαρτάται από τις ανάγκες του υπεύθυνου προσλήψεων και τον αριθμό των υποψηφίων. Αν δεν προχωρήσετε στο επόμενο στάδιο, δεν σημαίνει απαραίτητα ότι δεν είστε κατάλληλος υποψήφιος. Συχνά πρόκειται για πολύ συγκεκριμένες απαιτήσεις για αυτή τη θέση. Δείτε τις ερωτήσεις παρακάτω και δείξτε πιο καθαρά πώς καλύπτετε την προϋπόθεση, για παράδειγμα πιστοποιήσεις, διαθεσιμότητα ή χρόνια εμπειρίας.",
            "GotPotential_DescriptionSecondary": "Η αξιολόγηση του Hubert είναι μόνο συμβουλευτική. Την τελική απόφαση παίρνει ο υπεύθυνος προσλήψεων και άλλοι παράγοντες, όπως ο αριθμός των υποψηφίων, μπορεί να επηρεάσουν το αποτέλεσμα.",
            "GreatMatch_Title": "Ισχυρή αντιστοίχιση",
            "GreatMatch_Description": "Οι απαντήσεις σας ταιριάζουν καλά με αυτό που συνήθως αναζητούν οι υπεύθυνοι προσλήψεων σε αυτόν τον ρόλο και καλύπτετε τις απαιτήσεις. Ο υπεύθυνος προσλήψεων θα εξετάσει όλους τους υποψηφίους και θα αποφασίσει τα επόμενα βήματα.",
            "GreatMatch_DescriptionSecondary": "Η αξιολόγηση του Hubert είναι μόνο συμβουλευτική. Την τελική απόφαση παίρνει ο υπεύθυνος προσλήψεων και άλλοι παράγοντες, όπως ο αριθμός των υποψηφίων, μπορεί να επηρεάσουν το αποτέλεσμα. Αν δεν προχωρήσετε στο επόμενο στάδιο, δεν σημαίνει απαραίτητα ότι δεν είστε κατάλληλος υποψήφιος. Συχνά πρόκειται για πολύ συγκεκριμένες απαιτήσεις για αυτή τη θέση. Δείτε τις ερωτήσεις παρακάτω και δείξτε πιο καθαρά πώς καλύπτετε την προϋπόθεση, για παράδειγμα πιστοποιήσεις, διαθεσιμότητα ή χρόνια εμπειρίας.",
            "OkMatch_Title": "Καλύπτετε τις απαιτήσεις, ενισχύστε τον αντίκτυπο",
            "OkMatch_Description": "Καλύπτετε τις βασικές απαιτήσεις. Για να ξεχωρίσετε, προσθέστε περισσότερη σαφήνεια και αποδείξεις στις απαντήσεις σας. Ένας απλός τρόπος είναι ένα παράδειγμα ανά ερώτηση, τι κάνατε και ποιο ήταν το αποτέλεσμα, ιδανικά με έναν αριθμό ή ένα μετρήσιμο αποτέλεσμα.",
            "OkMatch_DescriptionSecondary": "Η αξιολόγηση του Hubert είναι μόνο συμβουλευτική. Την τελική απόφαση παίρνει ο υπεύθυνος προσλήψεων και άλλοι παράγοντες, όπως ο αριθμός των υποψηφίων, μπορεί να επηρεάσουν το αποτέλεσμα.",
            "NotClearMatch_Title": "Ίσως δεν είναι η σωστή αντιστοίχιση, ακόμη",
            "NotClearMatch_Description": "Με βάση αυτή τη συνέντευξη, οι απαντήσεις σας μπορεί να είναι λιγότερο ευθυγραμμισμένες με αυτό που χρειάζεται ο ρόλος, ή μία προϋπόθεση είναι ασαφής. Ξεκινήστε από τις ερωτήσεις παρακάτω. Μικρές βελτιώσεις, περισσότερα συγκεκριμένα στοιχεία και καθαρά αποτελέσματα μπορούν να αλλάξουν σημαντικά τη συνολική εικόνα την επόμενη φορά.",
            "NotClearMatch_DescriptionSecondary": "Η αξιολόγηση του Hubert είναι μόνο συμβουλευτική. Την τελική απόφαση παίρνει ο υπεύθυνος προσλήψεων και άλλοι παράγοντες, όπως ο αριθμός των υποψηφίων, μπορεί να επηρεάσουν το αποτέλεσμα."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Επαγγελματικές εμπειρίες, κίνητρα και ικανότητες",
            "QualifyingRequirements": "Απαιτήσεις καταλληλότητας για αυτήν τη συγκεκριμένη θέση",
            "NotQualified_Title": "Ενισχύστε τις απαντήσεις",
            "NotQualified_Description": "Κάποιες απαντήσεις μπορεί να ήταν πολύ γενικές για αυτή τη θέση. Δείτε παρακάτω πού ένα συγκεκριμένο παράδειγμα, αριθμοί ή ένα καθαρό αποτέλεσμα μπορούν να κάνουν την απάντηση πιο δυνατή.",
            "GreatResults_Title": "Ισχυρές απαντήσεις",
            "GreatResults_Description": "Οι απαντήσεις σας δείχνουν ότι ταιριάζετε με τον ρόλο για τον οποίο κάνατε αίτηση. Αυτό βασίζεται στις προηγούμενες εμπειρίες σας, τα κίνητρα και τις ικανότητές σας. Μπράβο! Αν υπάρχει κάποια ερώτηση στην οποία η απάντηση θα μπορούσε να είναι καλύτερη, θα εμφανιστεί παρακάτω.",
            "MeetingRequirements_Title": "Καλύπτετε τις απαιτήσεις",
            "MeetingRequirements_Description": "Οι απαντήσεις σας δείχνουν ότι πληροίτε τις απαιτήσεις καταλληλότητας που έχει θέσει ο υπεύθυνος προσλήψεων για αυτήν τη θέση. Πολύ καλά.",
            "NotAllExpectationsMet_Title": "Λείπει μία ή περισσότερες απαιτήσεις",
            "NotAllExpectationsMet_Description": "Με βάση τις απαντήσεις σας, μία ή περισσότερες απαιτήσεις μπορεί να λείπουν ή να είναι ασαφείς, για παράδειγμα πιστοποιητικά, άδειες, επίπεδο εκπαίδευσης ή χρόνια εμπειρίας.",
            "ButtonText_FindOutPossibleReasons": "Μάθετε πιθανούς λόγους"
        },
        "ScriptFromInterview": {
            "Title": "Διαβάστε ολόκληρη τη συνέντευξή σας",
            "ButtonText_SeeWholeTranscript": "Διαβάστε τη συνέντευξη",
            "ButtonText_DeleteInterview": "Διαγραφή συνέντευξης",
            "Loading_Title": "Φόρτωση ...",
            "Loading_Subtitle": "Παρακαλώ περιμένετε όσο φορτώνουμε τη μεταγραφή της συνέντευξής σας."
        },
        "HowToImproveAtInterviews": {
            "Title": "Πώς να βελτιωθείτε στις συνεντεύξεις",
            "Subtitle_Questions": "Ακολουθούν κάποιες ερωτήσεις στις οποίες η απάντησή σας θα μπορούσε ενδεχομένως να βελτιωθεί.",
            "Subtitle_NoQuestions": "Δεν εντοπίσαμε ερωτήσεις που να χρειάζονται σημαντική βελτίωση για αυτή τη θέση.",
            "GreatMatch_Questions_Description": "Ακόμη κι αν φαίνεται να ταιριάζετε εξαιρετικά με τη θέση, μπορεί να υπάρχουν ερωτήσεις στις οποίες η απάντησή σας μπορεί να βελτιωθεί. Εάν εντοπίσαμε τέτοιες απαντήσεις, θα τις βρείτε παρακάτω. Γενική συμβουλή: Ακολουθήστε τις οδηγίες που δίνονται πριν από κάθε ερώτηση. Όταν απαντάτε σε ερώτηση σχετική με μια συγκεκριμένη κατάσταση, περιγράψτε την κατάσταση ΚΑΙ τις ενέργειές σας ΚΑΙ το αποτέλεσμα αυτών των ενεργειών. Η απάντηση “OK” δεν είναι επαρκής. Αλλά μην γράφετε και υπερβολικά μακροσκελείς απαντήσεις. Ο στόχος είναι ο υπεύθυνος προσλήψεων (ή ο Hubert) να κατανοήσει τις ικανότητες και τις εμπειρίες σας , όπως θα κάνατε και σε μια δια ζώσης συνέντευξη.",
            "GreatMatch_NoQuestions_Description": "Πιθανότατα τα πήγατε πολύ καλά σε όλες ή στις περισσότερες ερωτήσεις. Μπράβο.",
            "OkMatch_Questions_Description": "Παρακάτω θα βρείτε ερωτήσεις στις οποίες η απάντησή σας θα μπορούσε να βελτιωθεί. Γενική συμβουλή: Ακολουθήστε τις οδηγίες πριν από κάθε ερώτηση. Περιγράψτε την κατάσταση ΚΑΙ τις ενέργειές σας ΚΑΙ το αποτέλεσμα αυτών. Η απάντηση “OK” δεν είναι επαρκής. Αποφύγετε υπερβολικά μακροσκελείς απαντήσεις. Ο υπεύθυνος πρέπει να καταλάβει τις εμπειρίες και ικανότητές σας.",
            "OkMatch_NoQuestions_Description": "Αν και θεωρηθήκατε κατάλληλος/η σε ικανοποιητικό βαθμό για αυτή τη θέση, ενδέχεται να μην υπάρχουν συγκεκριμένες απαντήσεις προς βελτίωση. Πιθανόν οι υπεύθυνοι να είχαν πολύ υψηλές απαιτήσεις , κάτι που είναι συχνό σε θέσεις με υψηλό ανταγωνισμό.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Γενική συμβουλή: Ακολουθήστε τις οδηγίες πριν από κάθε ερώτηση. Περιγράψτε την κατάσταση ΚΑΙ τις ενέργειές σας ΚΑΙ το αποτέλεσμα αυτών. Αποφύγετε απλές απαντήσεις όπως “OK”, και μην απαντάτε με μεγάλη έκταση. Να είστε κατανοητοί και ουσιαστικοί, όπως σε μια προσωπική συνέντευξη.",
            "GotPotential_Questions_Description": "Αν και δείχνετε να ταιριάζετε καλά με αυτού του είδους τη θέση, υπάρχουν ερωτήσεις στις οποίες η απάντηση μπορεί να βελτιωθεί. Αν τις εντοπίσαμε, θα τις βρείτε παρακάτω. Ακολουθήστε τις οδηγίες και περιγράψτε κατάσταση, ενέργειες και αποτελέσματα με σαφήνεια.",
            "GotPotential_NoQuestions_Description": "Δεν εντοπίσαμε ερωτήσεις που να χρειάζονται σημαντική βελτίωση σε επαγγελματικές δεξιότητες και κίνητρα. Οι απαντήσεις σας φαίνονται καλές.",
            "NotClearMatch_Questions_Description": "Παρακάτω θα βρείτε ερωτήσεις στις οποίες η απάντησή σας μπορεί να βελτιωθεί. Ακολουθήστε τις οδηγίες πριν από κάθε ερώτηση και απαντήστε περιγράφοντας την κατάσταση, τις ενέργειες και τα αποτελέσματά σας. Αποφύγετε απλές απαντήσεις όπως “OK”.",
            "NotClearMatch_NoQuestions_Description": "Δεν εντοπίσαμε ερωτήσεις προς βελτίωση. Αν και δεν θεωρηθήκατε ξεκάθαρα κατάλληλος/η για αυτήν τη θέση, ενδέχεται άλλοι υποψήφιοι να έδωσαν εξαιρετικά καλές απαντήσεις, ανεβάζοντας τον πήχη.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Γενική συμβουλή: Απαντήστε με βάση τις οδηγίες και περιγράψτε σαφώς την κατάσταση, τις ενέργειές σας και τα αποτελέσματα. Αποφύγετε την απάντηση “OK” και μη γράφετε υπερβολικά μεγάλα κείμενα. Η σαφήνεια είναι το κλειδί.",
            "Alert_WantMoreAdvice": "Θέλετε περισσότερες συμβουλές για το πώς να αποδώσετε καλύτερα στη συνέντευξη Hubert",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Διαβάστε το άρθρο με τις γενικές μας συμβουλές"
        },
        "SimilarOffers": {
            "Title": "Παρόμοιες θέσεις"
        },
        "HowHubertScoresInterviews": {
            "Title": "Πώς αξιολογεί ο Hubert τις συνεντεύξεις",
            "Description": "Παρακάτω περιγράφεται συνοπτικά πώς αξιολογεί ο Hubert τις απαντήσεις στις συνεντεύξεις. Έχουμε επίσης προσθέσει μια ενότητα για τη διαδικασία πρόσληψης, ώστε να γνωρίζετε τα επόμενα βήματα.",
            "Tabs_PossibleOutcomes": "Πιθανά αποτελέσματα",
            "Tabs_RecruitmentProcess": "Διαδικασία πρόσληψης",
            "AssessedMatch_Title": "Αξιολογημένη αντιστοίχιση",
            "AssessedMatch_Description": "Ο Hubert αξιολογεί κατά πόσο οι απαντήσεις σας ευθυγραμμίζονται με τις προσδοκίες των υπευθύνων προσλήψεων και αν πληροίτε τις βασικές απαιτήσεις για τη θέση. Ανάλογα με την απόδοσή σας, τοποθετείστε σε μία από τις τέσσερις κατηγορίες.",
            "AssessedMatch_DescriptionSecondary": "Η αξιολόγηση του Hubert είναι μόνο συμβουλευτική. Την τελική απόφαση παίρνει ο υπεύθυνος προσλήψεων και άλλοι παράγοντες, όπως ο αριθμός των υποψηφίων, μπορεί να επηρεάσουν το αποτέλεσμα.",
            "GreatMatch_Title": "Ισχυρή αντιστοίχιση",
            "GreatMatch_Description": "Οι απαντήσεις σας ευθυγραμμίζονται καλά με τις προσδοκίες των υπευθύνων προσλήψεων και πληροίτε τις βασικές απαιτήσεις της θέσης.",
            "GotPotential_Title": "Ισχυρό δυναμικό, λείπει μία προϋπόθεση",
            "GotPotential_Description": "Έχετε υψηλή βαθμολογία σε εμπειρία, κίνητρα ή ικανότητες, αλλά δεν πληροίτε μία ή περισσότερες βασικές απαιτήσεις της θέσης.",
            "OkMatch_Title": "Καλύπτετε τις απαιτήσεις, ενισχύστε τον αντίκτυπο",
            "OkMatch_Description": "Πληροίτε τις βασικές απαιτήσεις, αλλά οι απαντήσεις σας βαθμολογήθηκαν χαμηλότερα από τον μέσο όρο.",
            "NotClearMatch_Title": "Ίσως δεν είναι η σωστή αντιστοίχιση, ακόμη",
            "NotClearMatch_Description": "Οι απαντήσεις σας έχουν χαμηλότερη βαθμολογία και δεν πληροίτε βασικές απαιτήσεις που τέθηκαν από τον υπεύθυνο προσλήψεων.",
            "ProfessionalExperiences_Title": "Επαγγελματικές εμπειρίες, κίνητρα και ικανότητες",
            "ProfessionalExperiences_Description": "Αυτές οι ερωτήσεις αφορούν προηγούμενες εμπειρίες, τα κίνητρά σας και σχετικές ικανότητες. Οι υπεύθυνοι προσλήψεων επιλέγουν τις ερωτήσεις.",
            "GreatResults_Title": "Ισχυρές απαντήσεις",
            "GreatResults_Description": "Οι απαντήσεις σας δείχνουν ότι ταιριάζετε με τη θέση στην οποία υποβάλατε αίτηση.",
            "NotQualified_Title": "Ενισχύστε τις απαντήσεις",
            "NotQualified_Description": "Οι συνολικές απαντήσεις σας έχουν χαμηλή βαθμολογία και είναι κάτω από τις προσδοκίες των υπευθύνων προσλήψεων για τη θέση.",
            "QualifyingRequirements_Title": "Βασικές ή απαιτούμενες προϋποθέσεις για αυτή τη θέση",
            "QualifyingRequirements_Description": "Πρόκειται για ερωτήσεις που σχετίζονται με βασικές προϋποθέσεις όπως πτυχία, άδειες ή εμπειρία.",
            "MeetingRequirements_Title": "Καλύπτετε τις απαιτήσεις",
            "MeetingRequirements_Description": "Οι απαντήσεις σας δείχνουν ότι πληροίτε τις βασικές απαιτήσεις για αυτή τη θέση. Πολύ καλά.",
            "NotAllExpectationsMet_Title": "Λείπει μία ή περισσότερες απαιτήσεις",
            "NotAllExpectationsMet_Description": "Δεν πληροίτε μία ή περισσότερες από τις βασικές απαιτήσεις που έθεσε ο υπεύθυνος προσλήψεων.",
            "RecruitmentProcess_Title": "Διαδικασία πρόσληψης",
            "RecruitmentProcess_Description": "Ο Hubert χρησιμοποιείται συνήθως ως πρώτο στάδιο στις διαδικασίες πρόσληψης με πολλούς υποψήφιους. Όλες οι ερωτήσεις είναι ίδιες για όλους, προωθώντας τη δικαιοσύνη και μειώνοντας προκαταλήψεις.",
            "EventOne_Title": "Η συνέντευξη με τον Hubert",
            "EventOne_Description": "Δίνετε τη συνέντευξη με τον Hubert όποτε σας βολεύει. Δεν υπάρχουν χρονικοί περιορισμοί και μπορείτε να διακόψετε και να συνεχίσετε αργότερα.",
            "EventTwo_Title": "Αξιολόγηση της συνέντευξης",
            "EventTwo_Description": "Ο Hubert αξιολογεί τις απαντήσεις σας με σύγχρονη τεχνολογία. Τα αποτελέσματα εμφανίζονται άμεσα σε εσάς και στον υπεύθυνο προσλήψεων.",
            "EventThree_Title": "Επιλογή υποψηφίων για τα επόμενα βήματα",
            "EventThree_Description": "Οι υπεύθυνοι προσλήψεων εξετάζουν τις απαντήσεις και την αξιολόγησή σας. Μαζί με άλλες πληροφορίες αποφασίζουν για το επόμενο βήμα, για παράδειγμα τηλεφώνημα, τεστ ή τελική συνέντευξη, ή αν θα προχωρήσουν με άλλους υποψηφίους.",
            "ButtonText_Close": "Κλείσιμο"
        }
    },
    "MyProfile": {
        "Title": "Το προφίλ μου",
        "MyDetails": {
            "Title": "Τα στοιχεία μου",
            "Label_FirstName": "Όνομα",
            "Label_LastName": "Επώνυμο",
            "Label_Email": "Ηλεκτρονικό ταχυδρομείο",
            "Label_PhoneNumber": "Αριθμός τηλεφώνου",
            "ButtonText_UpdateDetails": "Ενημέρωση στοιχείων",
            "Error_FirstName_Required": "Το όνομα είναι υποχρεωτικό.",
            "Error_LastName_Required": "Το επώνυμο είναι υποχρεωτικό.",
            "Error_Email_Required": "Το email είναι υποχρεωτικό.",
            "Error_Email_Invalid": "Εισάγετε ένα έγκυρο email.",
            "Error_PhoneNumber_Invalid": "Ο αριθμός τηλεφώνου δεν είναι έγκυρος.",
            "Success_Details_Updated": "Το προφίλ ενημερώθηκε"
        },
        "ChangePassword": {
            "Title": "Αλλαγή κωδικού πρόσβασης",
            "Set_Password_Title": "Δημιουργία κωδικού πρόσβασης",
            "Label_CurrentPassword": "Τρέχων κωδικός πρόσβασης",
            "Label_NewPassword": "Νέος κωδικός πρόσβασης",
            "Label_RepeatNewPassword": "Επανάληψη νέου κωδικού πρόσβασης",
            "Alert_SignInAgain": "Παρακαλώ συνδεθείτε ξανά για να ορίσετε τον κωδικό πρόσβασης.",
            "ButtonText_UpdatePassword": "Ενημέρωση κωδικού πρόσβασης",
            "ButtonText_SetPassword": "Ορισμός κωδικού πρόσβασης",
            "ButtonText_SignInAgain": "Συνδεθείτε ξανά",
            "Error_CurrentPassword_Required": "Ο τρέχων κωδικός πρόσβασης είναι υποχρεωτικός.",
            "Error_CurrentPassword_DoesntMatch": "Ο κωδικός πρόσβασης δεν ταιριάζει με τον τρέχοντα.",
            "Error_NewPassword_Required": "Ο νέος κωδικός πρόσβασης είναι υποχρεωτικός.",
            "Error_NewPassword_6_Characters": "Ο νέος σας κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.",
            "Error_RepeatNewPassword_Required": "Η επανάληψη του νέου κωδικού είναι υποχρεωτική.",
            "Error_RepeatNewPassword_DoesntMatch": "Ο κωδικός δεν ταιριάζει με τον νέο κωδικό.",
            "Success_Password_Changed": "Ο κωδικός πρόσβασης ενημερώθηκε",
            "Error_Invalid_CurrentPassword": "Μη έγκυρος τρέχων κωδικός πρόσβασης."
        },
        "NotificationPreferences": {
            "Title": "Προτιμήσεις ειδοποιήσεων",
            "Label_ReceiveUpdatesToggle": "Θέλω να λαμβάνω ενημερώσεις από τον Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Θα λαμβάνετε οδηγούς καριέρας, συμβουλές για συνεντεύξεις και άλλα."
        },
        "AccountRemoval": {
            "Title": "Διαγραφή λογαριασμού",
            "ButtonText_RemoveMyAccount": "Διαγραφή του λογαριασμού μου"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Γεια σας",
        "Subtitle": "Πρόκειτε να ξεκινήσετε τη συνέντευξη.",
        "TipBox_Title": "Ορίστε μερικές συμβουλές απο εμάς που μπορούν να σας βοηθήσουν.",
        "TipBox_Tip1": "Κάντε τη συνέντευξη σε ένα ήσυχο μέρος ώστε να μπορείτε να συγκεντρωθείτε και να γράψετε άνετα.",
        "TipBox_Tip2": "Απαντήστε χρησιμοποιώντας υπολογιστή με πληκτρολόγιο (εκτός αν είστε εξοικειωμένοι/ες με την εκτενή γραφή στο κινητό).",
        "TipBox_Tip3": "Να είστε όσο πιο συγκεκριμένοι/ες και αναλυτικοί/ές γίνεται στις απαντήσεις σας. Ο Hubert και οι υπεύθυνοι προσλήψεων θέλουν πραγματικά να σας γνωρίσουν καλύτερα",
        "TipBox_Tip4": "Πάρτε το χρόνο που χρειάζεστε. Δεν υπάρχουν χρονικοί περιορισμοί.",
        "TipBox_Tip5": "Μπορείτε να κάνετε διάλειμμα οποιαδήποτε στιγμή και να συνεχίσετε απο εκεί που σταματήσατε.",
        "TipBox_Tip6": "Να είστε ο εαυτός σας και κάντε την συνέντευξη με τον Hubert με την ίδια σοβαρότητα που θα κάνατε σε μια συνέντευξη με φυσική παρουσία.",
        "CheckAdviceArticle_Text1": "Αν θέλεις περισσότερες συμβουλές για το πώς να πετύχεις στη συνέντευξη, δες αυτό το",
        "CheckAdviceArticle_Text2": "άρθρο",
        "CheckAdviceArticle_Text3": "με εξαιρετικές συμβουλές.",
        "ReadyToGetStarted": "Είστε έτοιμος/η να ξεκινήσετε",
        "ORSeparator_Text": "Ή",
        "ButtonText_StartInterviewNow": "Ξεκινήστε τη συνέντευξη τωρα",
        "ButtonText_SetReminder": "Δεν είμαι έτοιμος/η, ας ορίσουμε μια υπενθύμιση",
        "PrivacyPolicyText": "Πατώντας «ξεκινήστε τη συνέντευξη» συμφωνείτε με την",
        "PrivacyPolicyLink": "Πολιτική Απορρήτου και τους Όρους Χρήσης"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Μπράβο",
        "CompletedAlert_Subtitle": "Ολοκλήρωσες τη συνέντευξή σου.",
        "CompletedAlert_Description": "Οι υπεύθυνοι προσλήψεων θα εξετάσουν όλες τις αιτήσεις και θα παρέχουν ανατροφοδότηση μέσω email ή τηλεφώνου μόλις έχουν κάτι να ανακοινώσουν.",
        "InterviewNotCompleted": "Αυτή η συνέντευξη δεν έχει ολοκληρωθεί."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Κέντρο βοήθειας",
            "Subtitle": "Μάθετε τις απαντήσεις στις πιο συχνές ερωτήσεις σχετικά με τον Hubert.",
            "Label_Search": "αναζήτηση συχνών ερωτήσεων",
            "ButtonText_Search": "Αναζήτηση"
        },
        "FAQSection": {
            "Tabs_All": "Όλα",
            "Tabs_AboutHubertInterview": "Σχετικά με τη συνέντευξη Hubert",
            "Tabs_TechnicalSupport": "Τεχνική υποστήριξη"
        },
        "StillHaveQuestion": {
            "Title": "Έχετε ακόμα απορίες",
            "Description": "Χαιρόμαστε να σας βοηθήσουμε.",
            "DropUsAEmail": "Στείλτε μας email στο hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Μπορώ να κάνω τη συνέντευξη μέσω τηλεφωνικής κλήσης",
                    "a": "Ο Hubert λειτουργεί μόνο μέσω συνομιλίας αυτή τη στιγμή. Αν έχετε κάποιο ιατρικό πρόβλημα που σας εμποδίζει να δώσετε τη συνέντευξη, παρακαλώ επικοινωνήστε απευθείας με την εταιρεία πρόσληψης. Ο Hubert είναι υπεύθυνος μόνο για τις συνεντεύξεις συνομιλίας."
                },
                {
                    "q": "Μπορώ να κάνω τη συνέντευξη σε άλλη γλώσσα",
                    "a": "Σε ορισμένες από τις συνεντεύξεις μας υπάρχει δυνατότητα επιλογής γλώσσας στην αρχή της διαδικασίας. Αν λείπει αυτή η επιλογή, τότε η κατανόηση της συγκεκριμένης γλώσσας είναι πιθανόν απαίτηση της θέσης. Για περισσότερες πληροφορίες, παρακαλώ επικοινωνήστε με την εταιρεία πρόσληψης."
                },
                {
                    "q": "Θα τιμωρηθώ αν δώσω σύντομες απαντήσεις",
                    "a": "Όχι, δεν θα τιμωρηθείτε, αρκεί οι απαντήσεις σας να είναι κατάλληλες. Δεν υπάρχει ελάχιστο όριο λέξεων."
                },
                {
                    "q": "Μπορώ να χρησιμοποιήσω τις απαντήσεις μου από άλλη συνέντευξη με τον Hubert",
                    "a": "Ναι, μπορείτε να επαναχρησιμοποιήσετε προηγούμενες απαντήσεις αν έχετε συνδεθεί στο My Hubert και κάνετε αίτηση για παρόμοια θέση."
                },
                {
                    "q": "Θα διαβάσει άνθρωπος τη συνέντευξή μου",
                    "a": "Ναι, οι πελάτες μας καλούνται να ελέγχουν χειροκίνητα τις συνεντεύξεις."
                },
                {
                    "q": "Έχω ολοκληρώσει τη συνέντευξη, τι συμβαίνει τώρα",
                    "a": "Αφού ολοκληρωθεί η συνέντευξη, τα αποτελέσματα αποστέλλονται στον υπεύθυνο προσλήψεων μέσω του συστήματος αιτήσεων. Οι υπεύθυνοι προσλήψεων εξετάζουν τις απαντήσεις σας και την αξιολόγηση του Hubert. Με βάση αυτή και τη δική τους κρίση, αποφασίζουν αν θα προχωρήσετε στο επόμενο στάδιο της διαδικασίας, όπως τηλεφωνική επικοινωνία, τεστ ή τελική συνέντευξη."
                },
                {
                    "q": "Έχω απορία για τα επόμενα βήματα. Ποιον να ρωτήσω",
                    "a": "Παρακαλώ επικοινωνήστε με την εταιρεία στην οποία κάνατε αίτηση."
                },
                {
                    "q": "Πώς εξασφαλίζετε ότι δεν υπάρχει προκατάληψη στη διαδικασία πρόσληψης",
                    "a": "Η μείωση της προκατάληψης είναι πολύ σημαντική για εμάς. Ως μηχανή, ο Hubert μπορεί να είναι πολύ πιο συνεπής στην αξιολόγηση από έναν άνθρωπο. Τα μοντέλα μας εκπαιδεύονται από πολυάριθμους ειδικούς με διαφορετικά υπόβαθρα. Επίσης, ο Hubert δεν γνωρίζει τίποτα για το φύλο, την ηλικία, την εθνικότητα, τη θρησκεία ή την εμφάνιση του υποψηφίου , που είναι συχνοί λόγοι προκατάληψης στις παραδοσιακές συνεντεύξεις."
                },
                {
                    "q": "Μπορώ να δώσω συνέντευξη με άνθρωπο αντί για τον Hubert",
                    "a": "Παρακαλώ επικοινωνήστε με την εταιρεία στην οποία κάνατε αίτηση για να το συζητήσετε."
                },
                {
                    "q": "Είναι ο Hubert άνθρωπος",
                    "a": "Όχι, ο Hubert είναι ένα σύστημα συνεντεύξεων και ανάλυσης που βασίζεται σε υπολογιστή."
                },
                {
                    "q": "Μπορώ να αλλάξω τις απαντήσεις μου εκ των υστέρων",
                    "a": "Όχι, όπως και σε μια πραγματική συνέντευξη, δεν μπορείτε να επαναλάβετε τις απαντήσεις σας."
                },
                {
                    "q": "Πώς μπορώ να πετύχω στη συνέντευξη Hubert",
                    "a": "Διαβάστε προσεκτικά τις ερωτήσεις πριν απαντήσετε. Ακολουθήστε τις οδηγίες. Δώστε πραγματικά παραδείγματα από την εμπειρία σας και να είστε ειλικρινείς."
                },
                {
                    "q": "Χρειάζομαι δουλειά, ποιον πρέπει να επικοινωνήσω",
                    "a": "Παρακαλώ επικοινωνήστε με την εταιρεία στην οποία κάνατε αίτηση."
                },
                {
                    "q": "Έχω ολοκληρώσει τη συνέντευξη αλλά δεν έχω λάβει καμία ενημέρωση. Τι να κάνω",
                    "a": "Με βάση την αξιολόγηση του Hubert και τη δική τους κρίση, οι υπεύθυνοι προσλήψεων αποφασίζουν αν θα προχωρήσετε στο επόμενο στάδιο. Το επόμενο βήμα μπορεί να είναι τηλεφωνική συνέντευξη, τεστ ή τελική συνέντευξη. Αν θεωρήσουν ότι άλλοι υποψήφιοι ταιριάζουν καλύτερα, μπορεί να αποφασίσουν να προχωρήσουν με αυτούς. Επικοινωνήστε με τον υπεύθυνο προσλήψεων για να ενημερωθείτε για την πορεία της αίτησής σας."
                },
                {
                    "q": "Έχω μεγάλη εμπειρία, αλλά δεν πήρα τη δουλειά. Γιατί",
                    "a": "Ίσως η εμπειρία σας να μην ήταν επαρκής. Να θυμάστε ότι μπορεί να υπάρχουν πολλοί κατάλληλοι υποψήφιοι για τη θέση και να υπάρχει ανταγωνισμός. Αν απορριφθεί η αίτησή σας, μπορείτε να επικοινωνήσετε με την εταιρεία για να ρωτήσετε γιατί. Επίσης, μπορείτε να επισκεφθείτε το My Hubert για σχόλια σχετικά με τις απαντήσεις σας και να δείτε άλλες διαθέσιμες θέσεις εργασίας."
                },
                {
                    "q": "Πόση ώρα διαρκεί η συνέντευξη",
                    "a": "Εξαρτάται από τον αριθμό των ερωτήσεων που έχει ορίσει ο υπεύθυνος προσλήψεων. Υπολογίστε από 10 έως 25 λεπτά για να ολοκληρώσετε τη συνέντευξη. Μην βιαστείτε. Αν χρειαστεί, μπορείτε να κάνετε ένα διάλειμμα και να συνεχίσετε αργότερα."
                },
                {
                    "q": "Πού μπορώ να διαβάσω για το πώς διαχειρίζεστε τα δεδομένα μου",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Γιατί δεν μπορώ να δω τις προηγούμενες συνεντεύξεις μου με τον Hubert",
                    "a": "Βεβαιωθείτε ότι χρησιμοποιήσατε την ίδια διεύθυνση email για την αίτηση εργασίας με αυτήν που χρησιμοποιήσατε για να συνδεθείτε στο My Hubert. Το ίδιο ισχύει και όταν χρησιμοποιείτε το Google login. Πρέπει να διασφαλίσετε ότι η σύνδεση με την Google χρησιμοποιεί την ίδια διεύθυνση email με αυτήν της αίτησης. Δοκιμάστε να δημιουργήσετε λογαριασμό με τη διεύθυνση email που χρησιμοποιήσατε για την αίτηση."
                },
                {
                    "q": "Γιατί δεν έλαβα email για τη συνέντευξή μου",
                    "a": "Ελέγξτε τον φάκελο ανεπιθύμητης αλληλογραφίας. Μπορείτε επίσης να προσθέσετε τη διεύθυνση hubert@hubert.ai στις επαφές σας. Ή δημιουργήστε λογαριασμό στο My Hubert (χρησιμοποιώντας την ίδια διεύθυνση email που χρησιμοποιήσατε στην αίτηση) και πηγαίνετε στη σελίδα της συνέντευξης για να βρείτε τον σύνδεσμο εκεί."
                },
                {
                    "q": "Δεν μπορώ να βρω τον σύνδεσμο της συνέντευξης στο email μου.",
                    "a": "Μετακινήστε το email από τα ανεπιθύμητα στα εισερχόμενα. Ή δημιουργήστε λογαριασμό στο My Hubert (με την ίδια διεύθυνση email που χρησιμοποιήσατε στην αίτηση εργασίας) και πηγαίνετε στο 'Οι συνεντεύξεις μου' για να βρείτε τον σύνδεσμο εκεί."
                },
                {
                    "q": "Λειτουργεί η συνέντευξη σε κινητές συσκευές",
                    "a": "Ναι, λειτουργεί! Αλλά αν σας βολεύει περισσότερο η πληκτρολόγηση σε υπολογιστή, χρησιμοποιήστε υπολογιστή αντί για κινητό."
                },
                {
                    "q": "Η συνέντευξη δεν λειτουργεί. Τι να κάνω",
                    "a": "Λυπούμαστε για την αναστάτωση. Παρακαλώ στείλτε μας email στο hubert@hubert.ai και θα σας βοηθήσουμε."
                },
                {
                    "q": "Θέλω να διαγράψω ολόκληρο τον λογαριασμό μου στο My Hubert. Τι να κάνω",
                    "a": "Στείλτε μας email στο hubert@hubert.ai και θα σας βοηθήσουμε."
                },
                {
                    "q": "Η συνέντευξη διακόπηκε, πώς μπορώ να συνεχίσω",
                    "a": "Κάντε κλικ στον σύνδεσμο στην πρόσκληση μέσω email για να επιστρέψετε εκεί που διακόπηκε. Ή συνδεθείτε στο My Hubert και κάντε κλικ στη συνέντευξη στην ενότητα 'Οι συνεντεύξεις μου'."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Μάθε με τον Hubert",
            "Subtitle": "Μάθε πώς να αυξήσεις τις πιθανότητές σου στη διαδικασία πρόσληψης και να αποδώσεις καλύτερα στη δουλειά.",
            "Label_Search": "αναζήτησε οδηγούς για συνεντεύξεις και καριέρα",
            "ButtonText_Search": "Αναζήτηση"
        },
        "TabSelector": {
            "MyFeed": "Η ροή μου",
            "InterviewGuides": "Οδηγοί συνεντεύξεων",
            "CareerGuides": "Οδηγοί καριέρας"
        },
        "NewestOnTheFeed": "Τα πιο πρόσφατα στη ροή",
        "PickedForMe": "Τελευταία άρθρα",
        "InterviewGuides": "Οδηγοί συνεντεύξεων",
        "CareerGuides": "Οδηγοί καριέρας"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Επιστροφή σε όλα τα άρθρα"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Επαναφορά κωδικού πρόσβασης",
        "ResetLinkAlert_Subtitle": "Κάνε κλικ στον σύνδεσμο επαναφοράς που στάλθηκε στο email σου για να ορίσεις νέο κωδικό και να συνδεθείς στον λογαριασμό σου.",
        "PasswordNotSetAlert_Message": "Δεν έχει οριστεί κωδικός, παρακαλώ συνδέσου χρησιμοποιώντας",
        "ResetYourPassword": {
            "MainTitle": "Θέλεις να δεις τα αποτελέσματα της συνέντευξης σου με τον Hubert",
            "Subtitle": "Συνδέσου για να δεις αποτελέσματα, να λάβεις ανατροφοδότηση, να διαβάσεις συμβουλές και πολλά άλλα.",
            "FormSectionTitle": "Επαναφορά κωδικού πρόσβασης",
            "Label_NewPassword": "Νέος κωδικός πρόσβασης",
            "Label_ConfirmNewPassword": "Επιβεβαίωση νέου κωδικού πρόσβασης",
            "Error_NewPassword_Required": "Παρακαλώ εισάγετε νέο κωδικό.",
            "Error_Password_6_Characters": "Ο νέος κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.",
            "Error_ConfirmNewPassword_Required": "Πρέπει να επιβεβαιώσετε τον νέο σας κωδικό.",
            "Error_ConfirmNewPassword_NotMatch": "Ο κωδικός δεν ταιριάζει με τον νέο κωδικό",
            "Error_MalformedResetUrl": "Μη έγκυρος κωδικός ασφαλείας. Παρακαλώ προσπαθήστε ξανά",
            "Error_ResetPasswordFailed": "Υπήρξε πρόβλημα με την επαναφορά του κωδικού. Παρακαλώ προσπαθήστε ξανά",
            "Error_WeakPassword": "Ο κωδικός πρέπει να περιέχει τουλάχιστον 6 χαρακτήρες.",
            "Error_InvalidCode_Title": "Η αίτηση επαναφοράς του κωδικού έχει λήξει ή δεν είναι έγκυρη.",
            "Error_InvalidCode_Subtitle": "Παρακαλώ προσπαθήστε να επαναφέρετε τον κωδικό σας ξανά",
            "ButtonText_SetNewPassword": "Ορισμός νέου κωδικού & σύνδεση",
            "ButtonText_RememberYourPassword": "Θυμάσαι τον κωδικό σου",
            "ButtonText_SignInInstead": "Συνδέσου αντί αυτού"
        }
    },
    "PageNotFound": {
        "Title": "Η σελίδα δεν βρέθηκε",
        "Description": "Ωχ, δεν μπορούμε να βρούμε τη σελίδα που αναζητάτε.",
        "ButtonText_GoToDashboard": "Μετάβαση στον πίνακα ελέγχου",
        "ButtonText_GoToLogin": "Μετάβαση στη σύνδεση"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Για την ενημέρωσή σας, η επαναχρησιμοποίηση απαντήσεων δεν είναι ακόμα διαθέσιμη για αυτή τη συνέντευξη. Αναμένουμε να είναι διαθέσιμη τις επόμενες ημέρες ή εβδομάδες, αλλά μπορείτε ακόμα να προχωρήσετε στη συνέντευξη.",
        "DescriptionLine2": "Παρακαλώ προχωρήστε στη συνέντευξη τώρα κάνοντας κλικ στο κουμπί παρακάτω.",
        "ButtonText_TakeMeToTheInterview": "Μετάβασή μου στη συνέντευξη"
    },
    "UnsubscribeFromEmails": {
        "Title": "Είστε σίγουροι",
        "Subtitle": "Θα σταματήσετε να λαμβάνετε email από εμάς σχετικά με αυτή τη δουλειά.",
        "SelectTheReason": "Παρακαλώ επιλέξτε έναν λόγο από τις παρακάτω επιλογές.",
        "ReasonText1": "Βρήκα άλλη δουλειά.",
        "ReasonText2": "Δεν με ενδιαφέρει πλέον αυτή η δουλειά.",
        "ReasonText3": "Άλλο",
        "ButtonText_Unsubscribe": "Απεγγραφή από αυτή τη δουλειά",
        "Placeholder_YourReason": "Ο λόγος σας",
        "Success_Title": "Απεγγραφήκατε επιτυχώς από περαιτέρω email σχετικά με αυτή τη δουλειά.",
        "Loading": "Φόρτωση...",
        "Error_YourReason_Required": "Παρακαλώ εισάγετε τον λόγο.",
        "Error_ServerIssue": "Η απεγγραφή απέτυχε λόγω σφάλματος διακομιστή."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Δοκιμάστε ξανά"
    },
    "Outreach": {
        "CandidateNotFound": "Ο υποψήφιος δεν βρέθηκε",
        "CandidateNotFoundDesc": "Δεν μπορέσαμε να βρούμε τις λεπτομέρειες της συνέντευξης που αναζητάτε.",
        "InterviewEnded": "Η συνέντευξη ολοκληρώθηκε",
        "InterviewEndedDesc1": "Αυτή η συνεδρία συνέντευξης έχει λήξει ή δεν είναι πλέον διαθέσιμη.",
        "InterviewEndedDesc2": "Σας ευχαριστούμε για τον χρόνο σας. Εάν έχετε ερωτήσεις, επικοινωνήστε με την ομάδα προσλήψεων.",
        "ReadyTitle": "Είστε έτοιμοι για τη συνέντευξή σας, {{firstName}};",
        "InvitationDesc": "Ο Hubert εκ μέρους της {{companyName}} σας προσκαλεί σε μια συνέντευξη μέσω chat που διαρκεί περίπου 1-2 λεπτά.",
        "Button_StartChat": "Έναρξη συνέντευξης μέσω chat",
        "CancelNotice": "Η έναρξη εδώ θα ακυρώσει την προγραμματισμένη κλήση για αυτήν τη θέση.",
        "PreferNotToContinue": "Προτιμάτε να μην συνεχίσετε;",
        "DeclineLabel": "Δεν ενδιαφέρομαι για αυτήν τη θέση. Μην με καλέσετε ή μου στείλετε ξανά μηνύματα για αυτήν τη θέση.",
        "Button_ConfirmAndDecline": "Επιβεβαίωση και απόρριψη",
        "Processing": "Επεξεργασία...",
        "Toast_DeclineSuccess": "Η συνέντευξη απορρίφθηκε με επιτυχία",
        "Toast_CancelVoiceInfo": "Η φωνητική συνέντευξη ακυρώθηκε. Η λειτουργία θα είναι σύντομα διαθέσιμη.",
        "Toast_CancelError": "Αποτυχία ακύρωσης της συνέντευξης. Παρακαλώ δοκιμάστε ξανά.",
        "Footer_WithdrawConsent": "Μπορείτε να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή. Μάθετε περισσότερα στην ",
        "Footer_PrivacyPolicySuffix": "πολιτική απορρήτου της ",
        "Footer_And": " και στην ",
        "Footer_HubertPrivacyLink": "πολιτική απορρήτου και τους όρους & προϋποθέσεις του Hubert",
        "Chat_InterviewWith": "Συνέντευξη με την {{companyName}}",
        "Chat_StatusConnected": "Συνδεδεμένος",
        "Chat_StatusError": "Σφάλμα",
        "Chat_StatusDisconnected": "Αποσυνδεδεμένος",
        "Chat_StatusConnecting": "Σύνδεση...",
        "Chat_ReadyToStart": "Έτοιμοι να ξεκινήσετε τη συνέντευξη;",
        "Chat_ButtonStart": "Έναρξη συνέντευξης",
        "Chat_SayHello": "Πείτε γεια για να ξεκινήσετε τη συνομιλία.",
        "Chat_EmptyState": "Στείλτε ένα μήνυμα για να ξεκινήσετε τη συνέντευξη.",
        "Chat_SelectLanguage": "Επιλέξτε τη γλώσσα σας",
        "Chat_Placeholder": "Πληκτρολογήστε το μήνυμά σας...",
        "Chat_ButtonSend": "Αποστολή",
        "Chat_ButtonBack": "Πίσω",
        "LoadingCandidateDetails": "Φόρτωση στοιχείων υποψηφίου...",
        "FetchingCandidateDetails": "Ανάκτηση στοιχείων υποψηφίου...",
        "Chat_StatusReady": "Αναμονή για σύνδεση...",
        "Chat_ForbiddenError": "Αυτή η συνέντευξη μέσω chat δεν είναι πλέον διαθέσιμη.",
        "Chat_GeneralError": "Αποτυχία έναρξης της συνομιλίας. Παρακαλώ δοκιμάστε ξανά αργότερα.",
        "Chat_SelectUiLanguage": "Γλώσσα μενού",
        "Chat_InterviewTitle": "Συνέντευξη εργασίας"
    }
}
